<template>
  <modal v-bind="$attrs" v-on="$listeners" :center="true">
    <template v-slot:body>
      <div>
        <el-row type="flex" justify="center">
          <el-col :span="18">
          <p id="delete-modal-desc">
              {{ descModal }}
          </p>
          </el-col>
        </el-row>
      </div>
    </template>
    <template v-slot:footer>
      <primary-button class="confirm-delete" ref="" @click.native="handleContinue">
        {{ $t('homework.remove') }}
      </primary-button>
      <tertiary-button class="confirm-cancel" @click.native="$emit('closed')">
        {{ $t('common.cancel') }}
      </tertiary-button>
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/common/Modal'
import PrimaryButton from '@/components/common/buttons/PrimaryButton'
import TertiaryButton from '@/components/common/buttons/TertiaryButton'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    page: {
      type: String,
      default:'detail',
    },
    descModal: {},
    nodeModal: {}
  },
  components: {
    Modal,
    PrimaryButton,
    TertiaryButton
  },
  computed: {
    getTitle() {
      return this.$t(this.$i18nLabelsHelper(this.currentOrganizationType, 'modals.delete.title'), {
        numberOfClasses: this.numberOfSelectedClasses
      })
    },
    ...mapGetters({
      currentOrganizationType: 'organization/currentOrganizationType'
    })
  },
  methods: {
    handleContinue() {
      this.$emit('closed');
      this.$emit('continute', this.nodeModal, this.nodeModal.data, "remove")
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/_colors.scss';

#delete-modal-desc {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: $black;
  margin: 4px auto;
}

.elsa-button.confirm-delete,
.elsa-button.confirm-delete:hover {
  background: $orange;
  border-radius: 8px;
}

.elsa-button.confirm-cancel,
.elsa-button.confirm-cancel:hover {
  border-radius: 8px;
  padding-left: 16px;
  padding-right: 16px;
}

::v-deep {
  .el-dialog.elsa-modal {
    .el-dialog__header,
    .el-dialog__body {
      //padding: 40px 40px 0 40px;
      // display: flex;
      background-color: white;
    }

    &.signup .el-dialog__body {
      padding: 0;
    }

    .el-dialog__header {
      border-top-left-radius: 16px;
      border-top-right-radius: 16px;
      min-height: 27.5px;
    }

    .el-dialog__body {
      border-top: none;
      & > *:not(p):not(.info) {
        padding-bottom: 6px;
        display: flex;
        flex-direction: column;
      }
    }

    .el-dialog__footer {
      padding: 0 20px 48px 20px;
      justify-content: center;
    }
  }
}
</style>
